<div class="login-wrapper">
  <div class="login-form">
    <button class="login-button" mat-raised-button (click)="login()">LOGIN</button>
    <div>{{versionInfo}}</div>
  </div>
</div>
